const points=[
    {
        id:0,
        type:1,
        pos:{
            x:`5.53rem`,
            y:`6.97rem`
        }
    },
    {
        id:1,
        type:1,
        pos:{
            x:`4.07rem`,
            y:`6.89rem`
        }
    },
    {
        id:2,
        type:1,
        pos:{
            x:`3.95rem`,
            y:`5.75rem`
        }
    },
    {
        id:3,
        type:1,
        pos:{
            x:`2.90rem`,
            y:`5.45rem`
        }
    },
    {
        id:4,
        type:2,
        pos:{
            x:`3.60rem`,
            y:`4.60rem`
        }
    },
    {
        id:5,
        type:1,
        pos:{
            x:`4.73rem`,
            y:`4.10rem`
        }
    },
    {
        id:6,
        type:1,
        pos:{
            x:`5.65rem`,
            y:`3.70rem`
        }
    },
    {
        id:7,
        type:1,
        pos:{
            x:`5.80rem`,
            y:`2.90rem`
        }
    },
    {
        id:8,
        type:1,
        pos:{
            x:`4.32rem`,
            y:`2.60rem`
        }
    },
    {
        id:9,
        type:1,
        pos:{
            x:`5.24rem`,
            y:`2.00rem`
        }
    },
    {
        id:10,
        type:1,
        pos:{
            x:`4.04rem`,
            y:`1.47rem`
        }
    },
    {
        id:11,
        type:1,
        pos:{
            x:`5.12rem`,
            y:`0.78rem`
        }
    },
    {
        id:12,
        type:1,
        pos:{
            x:`3.92rem`,
            y:`0.32rem`
        }
    },
    {
        id:13,
        type:2,
        pos:{
            x:`2.62rem`,
            y:`0rem`
        }
    },
    {
        id:14,
        type:1,
        pos:{
            x:`1.10rem`,
            y:`0.17rem`
        }
    },
    {
        id:15,
        type:1,
        pos:{
            x:`-0.05rem`,
            y:`0.84rem`
        }
    },
    {
        id:16,
        type:1,
        pos:{
            x:`0.60rem`,
            y:`1.60rem`
        }
    },
    {
        id:17,
        type:1,
        pos:{
            x:`1.90rem`,
            y:`1.84rem`
        }
    },
    {
        id:18,
        type:1,
        pos:{
            x:`2.28rem`,
            y:`2.65rem`
        }
    },
    {
        id:19,
        type:1,
        pos:{
            x:`1.30rem`,
            y:`3.12rem`
        }
    },
    {
        id:20,
        type:1,
        pos:{
            x:`0.12rem`,
            y:`3.28rem`
        }
    },
    {
        id:21,
        type:1,
        pos:{
            x:`0.50rem`,
            y:`4.18rem`
        }
    },
    {
        id:22,
        type:1,
        pos:{
            x:`1.24rem`,
            y:`4.88rem`
        }
    },
    {
        id:23,
        type:2,
        pos:{
            x:`0.08rem`,
            y:`5.32rem`
        }
    },
    {
        id:24,
        type:1,
        pos:{
            x:`0.84rem`,
            y:`6.28rem`
        }
    },
    {
        id:25,
        type:1,
        pos:{
            x:`1.96rem`,
            y:`6.64rem`
        }
    }
]

export default points